export enum EPurchaseStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
}
